import {FilterCollectionStore, RemoteCollectionStore, SortCollectionStore, StoreBuilder} from "@softline/core";
import {LieferantBestellung} from "../types/bestellung";

const remoteCollectionStore = RemoteCollectionStore.create<LieferantBestellung>();

export const WwsLieferantStore = new StoreBuilder(remoteCollectionStore)
  .add(FilterCollectionStore.create<LieferantBestellung>())
  .add(SortCollectionStore.create<LieferantBestellung>())
  .value;
